import RibbonFormatState from '../store/schema/RibbonFormatState';
import { mutatorAction } from 'satcheljs';
import {
    PendableFormatState,
    ElementBasedFormatState,
    EditorUndoState,
} from 'roosterjs-editor-types';

/**
 * First class states are the format states directly showing in ribbon, such as B/I/U/bullet/...
 * These states need to be updated after user changed cursor position or changed format
 */
const updateFirstClassState = mutatorAction(
    'updateRibbonFormatState',
    (
        formatViewState: RibbonFormatState,
        pendingState: PendableFormatState,
        elementBasedState: ElementBasedFormatState,
        undoState: EditorUndoState,
        hasReadonlyContent: boolean
    ) => {
        formatViewState.isBold = pendingState.isBold;
        formatViewState.isItalic = pendingState.isItalic;
        formatViewState.isUnderline = pendingState.isUnderline;
        formatViewState.isBullet = elementBasedState.isBullet;
        formatViewState.isNumbering = elementBasedState.isNumbering;
        formatViewState.isStrikeThrough = pendingState.isStrikeThrough;
        formatViewState.isSubscript = pendingState.isSubscript;
        formatViewState.isSuperscript = pendingState.isSuperscript;
        formatViewState.canUnlink = elementBasedState.canUnlink;
        formatViewState.canAddImageAltText = elementBasedState.canAddImageAltText;
        formatViewState.canUndo = undoState.canUndo;
        formatViewState.canRedo = undoState.canRedo;
        formatViewState.isBlockQuote = elementBasedState.isBlockQuote;
        formatViewState.hasReadonlyContent = hasReadonlyContent;
    }
);

export default updateFirstClassState;
